import { useTranslation } from 'react-i18next'
import { cx } from '../utils/cx'
import type { TimelineProps } from './types'
import './Timeline.css'

/** Línea de tiempo de estados (DESIGN.md §4): hitos de 20 px, línea de 2 px; fianza, peticiones y cambios. */
export function Timeline({ items, className }: TimelineProps) {
  const { t } = useTranslation()
  return (
    <ol className={cx('hp-timeline', className)}>
      {items.map((it, i) => (
        <li key={it.id ?? i} className={cx('hp-timeline__item', `hp-timeline__item--${it.state}`, it.tone === 'error' && 'hp-timeline__item--error')}>
          <span className="hp-timeline__rail" aria-hidden="true">
            <span className="hp-timeline__dot" />
            {i < items.length - 1 && <span className="hp-timeline__line" />}
          </span>
          <div className="hp-timeline__content">
            <div className="hp-timeline__title">
              {it.title}
              <span className="visually-hidden"> {t(`v2.ds.timeline.${it.state}`)}</span>
            </div>
            {it.date && <div className="hp-timeline__date tnum">{it.date}</div>}
            {it.description && <div className="hp-timeline__desc">{it.description}</div>}
          </div>
        </li>
      ))}
    </ol>
  )
}
